import Swiper, { Navigation, Thumbs } from 'swiper';

var swiperCertificateThumbs = new Swiper('.swiper-certificate__thumbs', {
    spaceBetween: 10,
    slidesPerView: 8,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
        320: {
            slidesPerView: 3
        },
        480: {
            slidesPerView: 5
        },
        768: {
            slidesPerView: 6
        },
        991: {
            slidesPerView: 8
        }
    }
});
var swiperCertificate = new Swiper('.swiper-certificate', {
    modules: [Thumbs, Navigation],
    spaceBetween: 10,
    navigation: {
        nextEl: '.next',
        prevEl: '.prev'
    },
    thumbs: {
        swiper: swiperCertificateThumbs
    }
});
